import Vue from 'vue'
import Router from 'vue-router'
import StartPage from '@/components/StartPage'
import Register from '@/components/Register'
import LandingPage from '@/components/LandingPage'
import FamilyTree from '@/components/FamilyTree'
import FamilyTreeBuild from '@/components/FamilyTreeBuild'
import FamilyTreeChange from '@/components/FamilyTreeChange'
import FamilyTreeInvite from '@/components/FamilyTreeInvite'
import FamilyTreeSendInvite from '@/components/FamilyTreeSendInvite'
import Error from '@/components/Error'
import ErrorInvite from '@/components/ErrorInvite'
import ErrorContact from '@/components/ErrorContact'
import ErrorContent from '@/components/ErrorContent'
import Faq from '@/components/Faq'
import Welcome from '@/components/Welcome'
import OptOut from '@/components/OptOut'
import ConfirmNumber from '@/components/ConfirmNumber'
import ConsentMinor from '@/components/ConsentMinor'
import EnterCode from '@/components/EnterCode'
import VerifyInvite from '@/components/VerifyInvite'
import VerifyDiagnose from '@/components/VerifyDiagnose'
import VerifyTimestamp from '@/components/VerifyTimestamp'
import VerifyGeneticTest from '@/components/VerifyGeneticTest'
import VerifyFacility from '@/components/VerifyFacility'
import VerifyMutation from '@/components/VerifyMutation'
import VerifyContactHospital from '@/components/VerifyContactHospital'
import Dashboard from '@/components/Dashboard'
import DashboardMinor from '@/components/DashboardMinor'
import DashboardNoReferral from '@/components/DashboardNoReferral'
import DashboardCardio from '@/components/DashboardCardio'
import Screening from '@/components/Screening'
import ScreeningMedicine from '@/components/ScreeningMedicine'
import ScreeningVeganDiet from '@/components/ScreeningVeganDiet'
import ScreeningDiet from '@/components/ScreeningDiet'
import ScreeningEgg from '@/components/ScreeningEgg'
import ScreeningCholesterol from '@/components/ScreeningCholesterol'
import ScreeningCholesterolExt from '@/components/ScreeningCholesterolExt'
import ScreeningCholesterolTimestamp from '@/components/ScreeningCholesterolTimestamp'
import CreateRemittance from '@/components/CreateRemittance'
/* eslint-disable */
import { handleSessionIdQueryParam } from '../plugins/queryparam'

// Silences NavigationDuplicated error
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landingpage',
      component: LandingPage,
      meta: {}
    },
    {
      path: '/login',
      name: 'startpage',
      component: StartPage,
      meta: {}
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {}
    },
    {
      path: '*', // all other paths,
      name: 'error', // goes to this,
      component: Error, // since most components are routed,
      meta: {}, // and neccessary for the application.
      props: true
    },
    {
      path: '/errorinvite',
      name: 'errorinvite',
      component: ErrorInvite,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/errorcontact',
      name: 'errorcontact',
      component: ErrorContact,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/errorcontent',
      name: 'errorcontent',
      component: ErrorContent,
      meta: {},
      props: true
    },
    {
      path: '/familytree',
      name: 'familytree',
      component: FamilyTree,
      meta: {
        requiresAuth: true,
        requiresIndexPatient: true
      }
    },
    {
      path: '/ftbuild/:type',
      name: 'ftbuild',
      component: FamilyTreeBuild,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ftchange/:type',
      name: 'ftchange',
      component: FamilyTreeChange,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/invite',
      name: 'familytreeinvite',
      component: FamilyTreeInvite,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sendinvite',
      name: 'familytreesendinvite',
      component: FamilyTreeSendInvite,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/faq/:page',
      name: 'faq',
      component: Faq,
      props: true
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome,
      meta: {
        requiresSessionId: true
      }
    },
    {
      path: '/optout',
      name: 'optout',
      component: OptOut,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: ConfirmNumber,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/entercode',
      name: 'entercode',
      component: EnterCode,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verifyinvite',
      name: 'verifyinvite',
      component: VerifyInvite,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verifydiagnose',
      name: 'verifydiagnose',
      component: VerifyDiagnose,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verifytimestamp',
      name: 'verifytimestamp',
      component: VerifyTimestamp,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verifygentest',
      name: 'verifygentest',
      component: VerifyGeneticTest,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verifyfacility',
      name: 'verifyfacility',
      component: VerifyFacility,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verifymutation',
      name: 'verifymutation',
      component: VerifyMutation,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verifycontacthospital',
      name: 'verifycontacthospital',
      component: VerifyContactHospital,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboardminor/:id(\\d+)',
      name: 'dashboardminor',
      component: DashboardMinor,
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: '/consentminor/:id(\\d+)',
      name: 'consentminor',
      component: ConsentMinor,
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: '/dashboardnf',
      name: 'dashboardnf',
      component: DashboardNoReferral,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboardcardio',
      name: 'dashboardcardio',
      component: DashboardCardio,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/screening/:fieldId(\\d+)',
      name: 'screening',
      component: Screening,
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: '/screeningmed',
      name: 'screeningmedicine',
      component: ScreeningMedicine,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/screeningvegan',
      name: 'screeningvegandiet',
      component: ScreeningVeganDiet,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/screeningdiet',
      name: 'screeningdiet',
      component: ScreeningDiet,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/screeningegg',
      name: 'screeningegg',
      component: ScreeningEgg,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/screeningcol',
      name: 'screeningcol',
      component: ScreeningCholesterol,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/screeningcolvals',
      name: 'screeningcolvals',
      component: ScreeningCholesterolExt,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/screeningcoltime',
      name: 'screeningcoltime',
      component: ScreeningCholesterolTimestamp,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/createremittance',
      name: 'createremittance',
      component: CreateRemittance,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

/* Route Guard */
router.beforeEach((to, from, next) => {
  handleSessionIdQueryParam()

  /* Prevent going back directly to dashboard (if prohibited), go through Welcome -> decideRouteByState */
  window.onpopstate = function () {
    const docLoc = document.location.toString()
    if (docLoc.includes('dashboard')) {
      window.location.href = window.location.origin.concat('/welcome')
    }
  }

  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (sessionStorage.getItem('jwt')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }

  if (to.matched.some(route => route.meta.requiresSessionId)) {
    if (sessionStorage.getItem('sessionId')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }

  if (to.matched.some(route => route.meta.requiresIndexPatient)) {
    if (sessionStorage.getItem('isIndexPatient')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js